module.exports = __webpack_public_path__ + "static/media/logoFullColorized.888ca42d.svg";